import { css } from '@emotion/css'

export const title = css`
  font-weight: 600;
  margin: 0;
  padding: .1em 0;
  font-size: 1.4em;
`

export const description = css`
  font-weight: normal;
  color: #B7B7B7;
  margin: 0;
  padding: .1em 0;
  font-size: 1em;
`
